<template>
    <section class="support-section">
        <v-img
            class="d-flex support-banner"
            src="../assets/bg/support_lg_bg.jpg"
        >
            <div class="top-content page-content support-title-wrapper">
                <div class="support-title-group">
                    <p class="support-title">Support</p>
                    <p class="support-subtitle">
                        How can we help you? Search our FAQs or contact us with
                        your questions.
                    </p>
                </div>
            </div>
        </v-img>
        <div class="page-content support-main">
            <v-row class="support-main-wrapper mx-0">
                <v-col cols="12" xl="6" class="pa-0">
                    <div class="support-acordion-wrapper">
                        <accordion
                            :items="$store.state.supportFAQ"
                            :analytics-prefix="'support: '"
                        ></accordion>
                    </div>
                </v-col>
                <v-col cols="12" xl="6" class="pa-0">
                    <div class="support-contact-form-wrapper">
                        <contact-form
                            class="support-contact-form"
                        ></contact-form>
                    </div>
                </v-col>
            </v-row>
        </div>
    </section>
</template>

<script>
import Accordion from '@/components/accordion';
import ContactForm from '@/components/Support/contact-form';
export default {
    name: 'support',
    components: { Accordion, ContactForm },
    metaInfo() {
        return {
            titleTemplate: `%s | Support`,
        };
    },
    created() {
        this.$store.dispatch('fetchSupportFAQ');
    },
};
</script>

<style lang="scss" scoped>
.support-section {
    position: relative;
    min-height: 100vh;
    min-width: 360px;
    background-color: #f7f7f7;
    overflow: hidden;
    .support-banner {
        max-height: 259px;
        min-height: 250px;
        .support-title-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            height: 100%;
            .support-title-group {
                margin-bottom: 10px;
                color: #212843;
                .support-title {
                    font-family: KlavikaNX-Medium, serif;
                    font-size: 36px;
                    font-weight: 500;
                    letter-spacing: normal;
                    line-height: normal;
                    margin-bottom: 15px;
                    text-transform: uppercase;
                }
                .support-subtitle {
                    font-size: 16px;
                    letter-spacing: normal;
                    line-height: normal;
                }
            }
        }
    }
    .support-main {
        margin-top: 60px;
        margin-bottom: 60px;
    }
    .support-acordion-wrapper {
        padding: 0 30px;
    }
}

@include break('xs') {
    .support-section {
        .support-acordion-wrapper {
            padding: 0;
        }
    }
}

@include break('sm') {
    .support-section {
        .support-banner .support-title-wrapper {
            justify-content: start;
            align-items: center;
            text-align: left;
            .support-title-group {
                margin-left: 30px;
                .support-title {
                    font-size: 42px;
                    margin-bottom: 20px;
                }
            }
        }
        .support-main {
            .support-main-container {
                max-width: 706px;
            }
        }
        .support-acordion-wrapper {
            padding: 0 10px;
        }
    }
}
@include break('md') {
    .support-section {
        .support-banner {
            max-height: 298px;
            .support-title-wrapper {
                .support-title-group {
                    margin-left: 50px;
                    .support-title {
                        font-size: 50px;
                        margin-bottom: 25px;
                    }
                }
            }
        }
        .support-main {
            margin-bottom: 80px;
            .support-main-container {
                max-width: 875px;
            }
        }
        .support-acordion-wrapper {
            padding: 0 30px;
        }
    }
}
@include break('lg') {
    .support-section {
        .support-banner {
            max-height: 325px;
            height: 325px;
            .support-title-wrapper {
                .support-title-group {
                    margin-left: 136px;
                    .support-title {
                        font-size: 60px;
                        margin-bottom: 25px;
                    }
                    .support-subtitle {
                        font-size: 24px;
                    }
                }
            }
        }
        .support-acordion-wrapper {
            padding: 0 106px;
        }
    }
}
@include break('xl') {
    .support-section {
        .support-main {
            .support-main-container {
                max-width: 1760px;
            }
        }
    }
}
</style>
